import React, { useState, useEffect } from "react";
import EmailReceiptForm from "./email-receipt-form";
import FormComposed from "components/form/form-composed";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { getAvailableLocales } from "components/i18n-provider";
import { PageSection, PageHeaderBar } from "components/page";

const EmailsForm = ({ intl, values, handleChange }) => {
  const [availableLocales, setAvailableLocales] = useState([]);

  useEffect(
    () => {
      let canceled = false;

      getAvailableLocales().then(locales => {
        if (!canceled) {
          setAvailableLocales(
            locales.map(value => ({ label: intl.formatMessage({ id: `common.locale.in.${value}` }), value })),
          );
        }
      });

      return () => (canceled = true);
    },
    [intl],
  );

  return (
    <>
      <PageHeaderBar subtitle title="app.page.event.form.emailReceipts" />
      <PageSection>
        <FormComposed
          name="emailReceipts"
          onChange={handleChange}
          elements={values.emailReceipts}
          emptyElement={{ email: "", locale: "" }}
          addSubformButtonText={intl.formatMessage({ id: "app.page.event.form.add.emailReceipts" })}
          elementComponent={EmailReceiptForm}
          elementComponentProps={{ availableLocales }}
        />
      </PageSection>
    </>
  );
};

EmailsForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(EmailsForm);
